import React, { useState } from "react";

const clients = [
    {
        id: 1,
        name: "Pondok Tahfidz Ummul Quro",
        logo: "/assets/merchant/ummul-quro.png",
        description:
            "Yayasan Pendidikan Cahaya Qur’an Bogor membuka Pesantren Tahfidz yaitu Pesantren Tahfidz Terpadu Ummul Quro Al-Islami yang berdiri sejak tahun 2017",
    },
    {
        id: 2,
        name: "Pondok Pesantren Al`Araf",
        logo: "/assets/merchant/al-araf.jpg",
        description:
            "Pondok Pesantren Al Al`Araf dengan Visi Terwujudnya peserta didik yang unggul dalam prestasi, berakhlakul mulia, berwawasan global berdasarkan iman dan taqwa",
    },
];

export default function ClientB2B() {
    const [selected, setSelected] = useState(clients[0]);

    return (
        <section className="py-20 bg-gray-50 min-h-screen">
            <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
                {/* LEFT SIDE - DETAIL */}
                <div className="bg-white rounded-2xl shadow-md p-8 h-full flex flex-col justify-center border border-gray-100">
                    <div className="flex flex-col items-center md:items-start text-center md:text-left">
                        {selected ? (
                            <>
                                <img
                                    src={selected.logo}
                                    alt={selected.name}
                                    className="h-24 mb-5 object-contain"
                                />
                                <h2 className="text-2xl font-bold text-gray-800 mb-3">
                                    {selected.name}
                                </h2>
                                <p className="text-gray-600 leading-relaxed">
                                    {selected.description}
                                </p>
                            </>
                        ) : (
                            <>
                                <h2 className="text-2xl font-bold text-gray-700 mb-3">
                                    Pilih Client B2B
                                </h2>
                                <p className="text-gray-500">
                                    Klik logo merchant di sebelah kanan untuk melihat detail
                                    integrasi sistem.
                                </p>
                            </>
                        )}
                    </div>
                </div>

                {/* RIGHT SIDE - LIST */}
                <div>
                    <h3 className="text-2xl font-semibold text-gray-800 mb-6 text-center md:text-left">
                        Local Clients
                    </h3>
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-5">
                        {clients.map((m) => (
                            <button
                                key={m.id}
                                onClick={() => setSelected(m)}
                                className={`flex flex-col items-center justify-center p-4 bg-white border rounded-xl shadow-sm hover:shadow-md transition transform hover:-translate-y-1 ${selected?.id === m.id
                                        ? "border-blue-500 shadow-md ring-2 ring-blue-100"
                                        : "border-gray-200"
                                    }`}
                            >
                                <img
                                    src={m.logo}
                                    alt={m.name}
                                    className="h-20 object-contain mb-2"
                                />
                                <span className="text-sm font-medium text-gray-700 text-center">
                                    {m.name}
                                </span>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
